import React, { useEffect, useState } from "react";
import ModalCreateTask from "./components/Utilities/AddMachine";
import { IMachine as Machine } from "./interfaces";
import { useAppDispatch, useAppSelector } from "./store/hooks";
import { modalActions } from "./store/Modal.store";
import {
  GetConfigurations,
  GetDisclaimerDoc,
  GetEligibalPlans,
  SaveNewMachine,
  machinesActions,
} from "./store/Machines.store";
import RoutesSection from "./components/TasksSection/RoutesSection";
import GlobalLoader from "./components/Utilities/GlobalLoader";
import Membership from "./components/TasksSection/MemberShip";
import Footer from "./components/Footer";
import SideBar from "./components/Menu/sidebar/SideBar";
import {
  MemberstackProtected,
  MemberstackProvider,
  SignInModal,
  useMemberstack,
} from "@memberstack/react";
import { useNavigate } from "react-router-dom";
import { setLoading } from "./store/globalLoaderSlice";
import { CurrentUser } from "./components/Service/EndPoints";
import DisclaimerDoc from "./components/TasksSection/DisclaimerDoc";

const App: React.FC = () => {
  const navigation = useNavigate();
  if (
    localStorage.getItem("users") === null ||
    localStorage.getItem("users") === undefined
  ) {
    localStorage.setItem("users", "");
  }

  const config = {
    publicKey: process.env.REACT_APP_API_KEY
      ? process.env.REACT_APP_API_KEY
      : "",
  };
  const modal = useAppSelector((state) => state.modal);
  const [loggedInUser, setloggedInUser] = useState(false);
  const dispatch = useAppDispatch();
  const [toggal, setToggal] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    const loggedInUser = CurrentUser();

    if (loggedInUser) {
      setloggedInUser(true);

      dispatch(
        GetEligibalPlans((data: any) => {
          localStorage.setItem("eligibalsub", JSON.stringify(data));
        })
      );

      dispatch(
        GetConfigurations((data: any) => {
          dispatch(machinesActions.machineRegLimit(data.RegMachineLimit));
          localStorage.setItem("configuraions", JSON.stringify(data));
         
        })
      );
    }
  }, [dispatch]);

  const closeModalCreateTask = () => {
    dispatch(modalActions.closeModalCreateTask());
  };

  const createNewTaskHandler = (machine: Machine) => {
    dispatch(
      SaveNewMachine(machine, function () {
        dispatch(machinesActions.addNewMachine(machine));
      })
    );
  };

  const Membershiptvalidation = (obj: any) => {
    setloggedInUser(true);
    localStorage.setItem("_ms-mem", JSON.stringify(obj));
    navigate("/strategies");
    window.location.reload();
  };

  const toggalMenu = () => {
    setToggal(() => !toggal);
  };
  return (
    <MemberstackProvider config={config}>
      <MemberstackProtected
        fallback={<GlobalLoader />}
        onUnauthorized={<SignInModal onSuccess={Membershiptvalidation} />}
      >
        <>

        
          <GlobalLoader />
          <div className="fixed top-0 left-0 z-40 w-64 h-screen">
            <SideBar isUserLoggedIn={loggedInUser} />
          </div>

          <div className="p-4 sm:ml-64 md:ml-64 lg:ml-64">
            <div className=" dark:border-gray-700">
              {modal.modalCreateTaskOpen && (
                <ModalCreateTask
                  onClose={closeModalCreateTask}
                  nameForm="Add a Machine"
                  onConfirm={createNewTaskHandler}
                />
              )}

              <RoutesSection />
              <Footer />
            </div>
          </div>
        </>
      </MemberstackProtected>
    </MemberstackProvider>
  );
};

export default App;
/* Vector 222 */
